export default __webpack_public_path__ + "static/media/order-created.95f0a8aa.svg";